import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NgClass } from '@angular/common';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-see-button-renderer',
    template: `
      @if (isClickable) {
        <a (click)="see()" [ngClass]="color || isFilterActive ? 'color' : ''" [style.color]="isFilterActive ? '#ff6c6c' : null">
          <span>{{ getLabel() }}</span>
        </a>
      } @else {
        <span [style.color]="isFilterActive ? '#ff6c6c' : null">{{ getLabel() }}</span>
      }
    `,
    styles: [`
    a {
      width: fit-content !important;
      position: absolute !important;
      left: 0 !important;
      right: 0 !important;
      margin: auto !important;
      cursor: pointer !important;
      top: 0;
      bottom: 0;
      height: fit-content;
      padding: 0 10px;
      border-radius: 3px;
      color: #000;

      &:hover {
        background-color: #3a546b;
        color: #fff !important;

        span {
          text-decoration: none !important;
        }

        &.color {
          background-color: #3a546b;
          color: #fff !important;
        }
      }

      span {
        text-decoration: underline;
      }
    }
  `],
    standalone: true,
    imports: [NbButtonModule, TranslateModule, NgClass],
})
export class SeeButtonRendererComponent implements ICellRendererAngularComp {

  @ViewChild('container', { read: ViewContainerRef })
  public container!: ViewContainerRef;
  private params: any;
  public color: boolean;
  public isClickable: boolean;
  public isFilterActive: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.color = params.color;
    this.isClickable = !params.isClickable || params.isClickable(params);
    this.isFilterActive = params.column?.isFilterActive() || false;
  }

  refresh(params: any): boolean {
    if (params) {
      this.params = params;
      this.isFilterActive = params.column?.isFilterActive() || false;
    }
    return true;
  }

  public see(): void {
    const res = this.returnedValue();
    
    if (this.params.callback) {
      this.params.callback(res);
    } else {
      this.params.context.see(res);
    }
  }

  public getLabel(): string {
    if (this.params.getLabel) {
      return this.params.getLabel(this.params);
    } else {
      return this.params.context.translate.instant('See');
    }
  }

  public returnedValue(): any {
    if (this.params.getReturnedValue) {
      return this.params.getReturnedValue(this.params);
    } else {
      return this.params.node.data.id;
    }
  }
}
